import { DataTable } from "@shopify/polaris";
import React, { useCallback } from "react";
import styled from "styled-components";

import {
    arrInvalid,
    formatTime,
    getFullName,
    handleError,
    objectInvalid,
} from "../../helper";
import ElementScrollable from "../shared/ElementScrollable";
import EmptyStatePolaris from "../shared/EmptyStatePolaris";
import PaginationPolaris from "../shared/PaginationPolaris";
import SkeletonPagePolaris from "../shared/SkeletonPagePolaris";
import ChannelTeamAction from "./channel-team-action";
import { useChannelTeamCtx } from "./context";

function ChannelTeamTable() {
    const { loading, error, channelTeams, setFilter, filter, total } =
        useChannelTeamCtx();

    const handlePaginationChange = useCallback(
        (offset, limit) => {
            setFilter({ offset, limit });
        },
        [setFilter],
    );

    let { limit, offset } = filter;
    const totalPage = Math.ceil(total / limit);
    const page = offset / limit + 1;
    const aggregation = {
        page,
        totalPage,
        offset,
        limit,
        onChange: handlePaginationChange,
        total,
    };

    return (
        <>
            <Wrapper>
                {loading ? (
                    <SkeletonPagePolaris />
                ) : error ? (
                    <div>Error: {handleError(error?.toString())}</div>
                ) : channelTeams?.length > 0 ? (
                    <>
                        {/* <SelectRow
                            data={channelTeams}
                            refetch={refetch}
                            actionMarkup={<AmazonIdeaBulkAction />}
                        >
                            {({ checkAllMarkup, checkItemMarkup }) => (
                                
                            )}
                        </SelectRow> */}
                        <ElementScrollable fixedColumn>
                            <DataTable
                                rows={
                                    getRows(
                                        channelTeams,
                                        // checkItemMarkup,
                                    ) || []
                                }
                                columnContentTypes={[
                                    ...Array.from({ length: 5 }).fill("text"),
                                    "numeric",
                                ]}
                                headings={[
                                    // checkAllMarkup,
                                    "ID",
                                    "Name",
                                    "Channel",
                                    "Members",
                                    "Created At",
                                    <div className="actions-wrap">Actions</div>,
                                ]}
                                hideScrollIndicator
                                verticalAlign="middle"
                            />
                        </ElementScrollable>
                        <PaginationContainer>
                            <PaginationPolaris
                                aggregation={aggregation}
                                showTotal
                            />
                        </PaginationContainer>
                    </>
                ) : (
                    <EmptyStatePolaris />
                )}
            </Wrapper>
        </>
    );
}

function getRows(nodes) {
    const res = [];

    for (const node of nodes) {
        if (objectInvalid(node)) continue;

        const { id, name, channel, createdAt, members } = node;

        const item = [
            // checkItemMarkup ? checkItemMarkup(id) : null,
            <div className="id item">
                <span>{id}</span>
            </div>,
            <div className="name item">
                <span>{name}</span>
            </div>,

            <div className="channel item">
                <span>{channel}</span>
            </div>,
            <div className="members item">
                <span>{getMemberInfo(members)}</span>
            </div>,
            <div className="created-at item">
                <span>{formatTime(createdAt)}</span>
            </div>,
            <div className="actions-wrap item">
                <ChannelTeamAction node={node} />
            </div>,
        ];

        res.push(item);
    }

    return res;
}

function getMemberInfo(members) {
    const res = [];
    if (arrInvalid(members)) return "";
    for (let item of members) {
        res.push(getFullName(item));
    }

    return res.join(", ");
}

const Wrapper = styled.div`
    overflow-x: auto;

    .Polaris-DataTable__ScrollContainer {
        overflow-x: inherit;
    }

    .item {
        white-space: normal;
        word-break: break-word;
    }

    .actions-wrap {
        width: calc(13.5rem - 3.2rem);
        margin-left: auto;
    }

    .author,
    .picker,
    .id,
    .created-at {
        width: calc(18rem - 3.2rem);
    }

    .personalized,
    .type,
    .kpi {
        width: calc(13rem - 3.2rem);
    }

    .status {
        width: calc(25rem - 3.2rem);
    }

    .title,
    .product {
        width: calc(20rem - 3.2rem);
    }
`;

const PaginationContainer = styled.div`
    padding: 1.6rem;
    overflow-x: scroll;
    background: var(--p-surface-subdued, #f4f6f8);
`;

export default ChannelTeamTable;
